import { call } from 'redux-saga/effects';
import { serviceTypeEnum } from '../API/types';

export function* chooseServiceGenerator(ocularis, cayuga, action) {
    switch (window.CONFIG.ServerType) {
        case serviceTypeEnum.ocularis:
            return yield call(ocularis.fn, ...ocularis.args, action && action);
        case serviceTypeEnum.cayuga:
            return yield call(cayuga.fn, ...cayuga.args, action && action);
        default:
            break;
    }
}

export const transformCayugaData = (data) => {
    let tempArr = [];
    if (Array.isArray(data)) {
        data.forEach(val => {
            const tempObj = transformCayugaObject(val)
            tempArr.push(tempObj);
        });
    } else if (typeof data === 'object') {
        tempArr = transformCayugaObject(data);
    }
    
    return tempArr;
}

const transformCayugaObject = (data) => {
    let tempObj = {};
    Object.keys(data).forEach(key => {
        const tempKey = key.indexOf('Entity') === -1 
                            ? key.replace('a:', '').toLowerCase()
                            : key.replace('a:', '').replace('Entity','').toLowerCase();

        tempObj[tempKey] = data[key];
    });
    return tempObj;
}
